export default function Footer() {
    return (
        <footer className="h-20 bg-neutral-600 bg-opacity-50 text-base 
            sm:text-4xl text-center flex justify-center items-center">
            &#169;2026 Recipe Site
        </footer>
    )
}